export default "__VITE_ASSET__AGlXT7se__"